/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-23T16:04:05.443
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveChannelpic,
	getChannelpicCreateInit,
	getChannelpicEditInit,
	getChannelpicView,
	deleteChannelpic
} from '@api/rentmanage/Channelpic';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getChannelpicCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getChannelpicCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getChannelpicEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getChannelpicEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveChannelpic({}, Channelpic) {
			return new Promise((resolve, reject) => {
				saveChannelpic(Channelpic)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getChannelpicView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getChannelpicView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteChannelpic({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteChannelpic({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
